import DataGridRowMenu from "components/DataGrid/DataGridRowMenu"
import { GroupAction } from "./Groups"
import { GridTreeNodeWithRender } from "@mui/x-data-grid-premium"


type GroupRowMenuProps = {
  rowNode: GridTreeNodeWithRender
  dispatch: React.Dispatch<GroupAction>
  setMenuRowId: (id: string | null) => void
  disableDelete: boolean
}

export function GroupRowMenu({
  rowNode,
  dispatch,
  setMenuRowId,
  disableDelete,
}: GroupRowMenuProps) {
  return (
    <DataGridRowMenu
      row={rowNode}
      label={`Group ${rowNode.id} Menu`}
      onOpen={(row) => setMenuRowId(`${row.id}`)}
      onClose={() => setMenuRowId(null)}
      items={[
        {
          key: 'edit',
          label: 'Edit Group',
          onClick: (row) => {
            dispatch({ type: 'OPEN_EDIT', groupId: `${row.id}` })
          },
        },
        {
          key: 'duplicate',
          label: 'Duplicate Group',
          onClick: (row) => {
            dispatch({ type: 'OPEN_DUPLICATE', groupId: `${row.id}` })
          },
        },
        {
          key: 'delete',
          label: 'Delete Group',
          onClick: (row) => {
            dispatch({ type: 'OPEN_DELETE', groupId: `${row.id}` })
          },
          disabled: disableDelete,
          tooltip: disableDelete ? 'Groups in use cannot be deleted.' : undefined,
        },
      ]}
    />
  )
}
